/* eslint-disable */
import React from 'react';
import {
    BaseFilter,
    ShowTitleByDescription,
    validateStaticDataWithCode,
} from './Scaffolding';
import {
    TextField,
    Datagrid,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { BooleanInput, TextInput } from '../lib/wrappers/Inputs';
import { EditToolbar } from '../layout/EditToolbar';

export const Tier4ArrangementLabels = {
    Title: 'Tier 4 Arrangement',
    description: 'Tier 4 Arrangement description',
    pageTitle: 'Tier 4 Arrangements',
};

export const Tier4ArrangementList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={Tier4ArrangementLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField
                        label={Tier4ArrangementLabels.Title}
                        source="Title"
                    />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const Tier4ArrangementCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm validate={validateStaticDataWithCode}>
            <TextInput label={Tier4ArrangementLabels.Title} source="Title" />
            <TextInput
                label={Tier4ArrangementLabels.description}
                source="description"
            />
            <BooleanInput source="current" />
        </SimpleForm>
    </Create>
);

export const Tier4ArrangementEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit {...props} title={<ShowTitleByDescription />} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput
                        label={Tier4ArrangementLabels.Title}
                        source="Title"
                    />
                    <TextInput
                        label={Tier4ArrangementLabels.description}
                        source="description"
                    />
                    <BooleanInput source="current" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const Tier4ArrangementShow = (props) => (
    <Show {...props} title={<ShowTitleByDescription />}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField label={Tier4ArrangementLabels.Title} source="Title" />
            <TextField
                label={Tier4ArrangementLabels.description}
                source="description"
            />
            <BooleanField source="current" />
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
